import { createContext, ReactNode, useReducer } from 'react';
import { trackingReducer } from './tracking-reducer';
import { TrackingAction, TrackingState } from './types';

export const TrackingProvider = ({ children }: { children: ReactNode }) => {
  const initialState: TrackingState = {
    id: null,
    weekId: null,
    actions: []
  };

  const [state, dispatch] = useReducer(trackingReducer, initialState);

  return (
    <TrackingStateContext.Provider value={state}>
      <TrackingDispatchContext.Provider value={dispatch}>
        {children}
      </TrackingDispatchContext.Provider>
    </TrackingStateContext.Provider>
  );
};

export const TrackingStateContext = createContext<TrackingState | undefined>(
  undefined
);

export const TrackingDispatchContext = createContext<
  React.Dispatch<TrackingAction> | undefined
>(undefined);
